export const sellChip = {
	title: "Fichas vendidas en el evento",
	addCollaborator: "Agregar colaborador",
	placeholder_one: "Seleccione el colaborador",
	placeholder_other: "Seleccione los colaboradores",
	noChipsFound: "Ninguna ficha encontrada",
	oneChipFound: "Una ficha encontrada",
	chipsFound: "{{num}} fichas encontradas",
	searchPlaceholder: "Buscar por cliente o producto",
	columns: {
		date: "Fecha",
		employee: "Empleado",
		clients: "Clientes",
		products: "Productos",
		value: "Valor",
		refunded: "Reembolsada",
		actionButton: "Reembolsar ficha",
	},
	modal: {
		title: "Reembolsar ficha de {{client}}",
		okText: "Reembolsar",
		product: "Producto",
		products: "Productos",
		reason: "Motivo",
		reasonRequired: "Motivo obligatorio.",
		reasonPlaceholder: "Ingrese el motivo del reembolso",
		shouldReturnToStorage: "¿Debe volver al inventario?",
		reasonError: "Este campo no puede estar vacío",
		returnToStorage: "Retornar producto al inventario",
	},
};
